import { MapProgram } from "./";
export class AreaMapResponse {
    public programs: MapProgram[];
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/area-map-response.ts